<template>
  <div class="box1">
    <div class="banner" @click="childMethod">
      <div class="banner-icon"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    childMethod() {
      this.$parent.itcastClick();
    }
  },
};
</script>

<style lang="less" scoped>
.box1 {
  // margin-bottom: 80px;
  position: relative;
  width: 100%;
  background: #0297ff;

  .banner {
    position: relative;
    width: 100%;
    height: 630px;
    background: url("../../assets/architect/banner.png") no-repeat;
    background-size: cover;
    // background-position: center;

    .banner-icon {
      position: absolute;
      right: 0px;
      // bottom: -50px;
      top: 228px;
      width: 231px;
      height: 332px;
      background: url("../../assets/architect/banner-icon.png")
        no-repeat;
      background-size: cover;
    }
  }
}
</style>
